<template>
  <div class="select-container">
    <div>
      <select 
        class="input-select"
        v-model="item"
        :class="{error:error}"
        :disabled="disabled"
        :multiple="false"
      >
        <option 
          v-for="(option,index) in selectOptions" 
          :key="index"
          :value="option.val"
          :selected="index === selectedIndex"
        >
          {{ option.label }}
        </option>
      </select>
    </div>
    <p class="input-error" v-if="error">{{ error }}</p>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'

export default defineComponent({
  props: ['options','modelValue', 'hasBlank', 'error', 'selectedIndex', 'disabled'],
  setup(props, context) {
    if (!props.modelValue && !props.hasBlank) {
      context.emit('update:modelValue', (props.options[0]) ? props.options[0].val : null)
    }
    const item = computed({
      get() {
        return props.modelValue
      },
      set(val) {
        context.emit('update:modelValue', val)
      }
    })
    const selectOptions = computed(() => {
      const options = Object.assign([], props.options)
      if (props.hasBlank) {
        options.unshift({
          val: null,
          label: ''
        })
      }
      return options
    })

    const selectedIndex = computed(()=>{
      return props.selectedIndex
    })

    return {
      item,
      selectOptions,
      selectedIndex
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/form/select-box.scss';
</style>